import { Components, Theme } from '@mui/material/styles';
import { FlowStepLabelIcon } from './StepLabelIcon';

export const flowStepLabel: Components<Theme>['MuiStepLabel'] = {
  defaultProps: {
    slots: {
      stepIcon: FlowStepLabelIcon,
    },
  },
  styleOverrides: {
    vertical: ({ theme }) => ({
      // default is 4px we need to shift it 6px bcs of design
      gap: theme.spacing(1.25),
      '& .MuiStepContent-root': {
        // default is 20px, we need to add 6px because we shift the label 6px
        paddingLeft: '26px',
      },
      '&:not(.MuiStepLabel-alternativeLabel)': {
        marginLeft: 0,
      },
    }),
    labelContainer: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
    iconContainer: {
      position: 'relative',
      borderRadius: '40px',
      padding: 0,
    },
    label: ({ theme }) => ({
      ...theme.typography.disclaimer,
      '&&': {
        fontWeight: '300',
      },
      '&.Mui-error': {
        color: 'currentColor',
      },
      '&.MuiStepLabel-alternativeLabel': {
        marginTop: '12px',
      },
      '&:not(.MuiStepLabel-alternativeLabel)': {
        marginLeft: '12px',
      },
    }),
  },
};
